import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/right-red.svg'


const _withScopeId = n => (_pushScopeId("data-v-25e47366"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "title-container"
}
const _hoisted_2 = { class: "leaderboard-title-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leaderboard-title-top-left parallelogram" }, null, -1))
const _hoisted_4 = { class: "leaderboard-title-top-desc" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leaderboard-title-top-right parallelogram" }, null, -1))
const _hoisted_6 = { class: "leaderboard-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leaderboard-title-bottom parallelogram" }, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "title-container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-nfts-title-top parallelogram" }, null, -1))
const _hoisted_10 = { class: "my-nfts-title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-nfts-title-bottom parallelogram" }, null, -1))
const _hoisted_12 = { class: "content" }
const _hoisted_13 = {
  key: 0,
  class: "current nft-main-card"
}
const _hoisted_14 = { class: "current-title" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-8" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "right-red",
    src: _imports_0
  })
], -1))
const _hoisted_16 = { class: "current-detail" }
const _hoisted_17 = { class: "for-rank-label" }
const _hoisted_18 = { class: "for-rank-label" }
const _hoisted_19 = { class: "for-rank-label" }
const _hoisted_20 = {
  key: 1,
  class: "nft-stats nft-main-card"
}
const _hoisted_21 = { class: "nft-stats-title" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nft-stats-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "right-red",
    src: _imports_0
  })
], -1))
const _hoisted_23 = { class: "nft-stats-detail" }
const _hoisted_24 = { class: "nft-stats-detail-total-minted" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 2,
  class: "nft-next-up nft-main-card"
}
const _hoisted_27 = { class: "nft-next-up-title" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-8" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "right-red",
    src: _imports_0
  })
], -1))
const _hoisted_29 = { class: "nft-next-up-detail" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 3,
  class: "leaderboard-list nft-main-card"
}
const _hoisted_32 = { class: "leaderboard-list-title" }
const _hoisted_33 = { class: "leaderboard-list-header" }
const _hoisted_34 = { class: "nfts-container" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "relative" }
const _hoisted_37 = {
  key: 4,
  class: "my-nfts-list nft-main-card"
}
const _hoisted_38 = { class: "my-nfts-list-title" }
const _hoisted_39 = { class: "my-nfts-list-header" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "my-nfts-container" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "my-nfts-list-item-character-cell" }
const _hoisted_44 = ["src"]
const _hoisted_45 = {
  key: 0,
  class: "my-nfts-list-item-cell"
}
const _hoisted_46 = { class: "my-nfts-list-item-cell" }
const _hoisted_47 = { class: "my-nfts-list-item-cell" }
const _hoisted_48 = { class: "my-nfts-list-item-cell" }
const _hoisted_49 = { class: "my-nfts-list-item-cell" }
const _hoisted_50 = { class: "my-nfts-list-footer" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-520" }, "*", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_MintSuccessModal = _resolveComponent("MintSuccessModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.currentPage.startsWith('leaderboard'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('anniversary_nft_stake_mint').toUpperCase()), 1),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('leaderboard').toUpperCase()), 1),
          _hoisted_7
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('my_nfts').toUpperCase()), 1),
          _hoisted_11
        ])),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.currentPage.startsWith('leaderboard'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('current_rank_levels').toUpperCase()), 1)
            ]),
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", null, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('for_rank_1').toUpperCase()) + ":  " + _toDisplayString(`> ${_ctx.forRnak1}`), 1)
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('for_rank_2').toUpperCase()) + ":  " + _toDisplayString(`> ${_ctx.forRnak2}`), 1)
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('for_rank_3').toUpperCase()) + ":  " + _toDisplayString(`> ${_ctx.forRnak3}`), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentPage === 'leaderboard_acs' || _ctx.currentPage === 'my_nfts')
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('acs_nft_stats').toUpperCase()), 1)
            ]),
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('anniversary_collection_acs').toUpperCase()), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('total_nft_minted').toUpperCase()) + ": " + _toDisplayString(_ctx.totalSupplyAcs || '--'), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('total_acs_staked').toUpperCase()) + ": " + _toDisplayString(_ctx.totalStakedAcs ? `${_ctx.showApr(_ctx.totalStakedAcs)} ACS` : '--'), 1),
              (_ctx.currentPage === 'my_nfts')
                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.$t('current_apy').toUpperCase()) + ": " + _toDisplayString(_ctx.currentApyAcs), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentPage === 'leaderboard_acsi' || _ctx.currentPage === 'my_nfts')
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('acsi_nft_stats')), 1)
            ]),
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('anniversary_collection_acsi').toUpperCase()), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('total_nft_minted').toUpperCase()) + ": " + _toDisplayString(_ctx.totalSupplyAcsi || '--'), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('total_acsi_staked').toUpperCase()) + ": " + _toDisplayString(_ctx.totalStakedAcsi ? `${_ctx.showApr(_ctx.totalStakedAcsi)} ACSI` : '--'), 1),
              (_ctx.currentPage === 'my_nfts')
                ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.$t('current_apy').toUpperCase()) + ": " + _toDisplayString(_ctx.currentApyAcsi), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentPage.startsWith('leaderboard'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t('leaderboard').toUpperCase()), 1),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('nos').toUpperCase()), 1),
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sort('stakedUsd'))),
                class: "cursor-pointer"
              }, _toDisplayString(_ctx.$t('price').toUpperCase()), 1),
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sort('rank'))),
                class: "cursor-pointer"
              }, _toDisplayString(_ctx.$t('current_rank').toUpperCase()), 1),
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sort('idInt'))),
                class: "cursor-pointer"
              }, _toDisplayString(_ctx.$t('nft')) + " # ", 1)
            ]),
            _createElementVNode("div", _hoisted_34, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showedNfts, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["leaderboard-list-item", { 'users-nft': _ctx.isUsersNft(item) }]),
                  onClick: ($event: any) => (_ctx.gotoNftViewer(item))
                }, [
                  _createElementVNode("div", _hoisted_36, [
                    (_ctx.isUsersNft(item))
                      ? (_openBlock(), _createBlock(_component_BalIcon, {
                          key: 0,
                          name: "ci:dot-03-m",
                          size: "xs",
                          class: "users-nft-icon"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(item.no), 1)
                  ]),
                  _createElementVNode("div", null, _toDisplayString(item.price ? `${item.priceShow}` : '--'), 1),
                  _createElementVNode("div", null, _toDisplayString(item.rank), 1),
                  _createElementVNode("div", null, "№" + _toDisplayString(item.id), 1)
                ], 10, _hoisted_35))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentPage === 'my_nfts')
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t('my_nfts').toUpperCase()), 1),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sort('character'))),
                class: "my-nfts-list-character-header cursor-pointer"
              }, _toDisplayString(_ctx.$t('character').toUpperCase()), 1),
              (!_ctx.upToLargeBreakpoint)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.$t('nos').toUpperCase()), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sort('stakedUsd'))),
                class: "cursor-pointer"
              }, _toDisplayString(_ctx.$t('price').toUpperCase()), 1),
              _createElementVNode("div", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sort('stakedUsd'))),
                class: "cursor-pointer"
              }, _toDisplayString(_ctx.$t('staked').toUpperCase()), 1),
              _createElementVNode("div", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sort('rank'))),
                class: "cursor-pointer"
              }, _toDisplayString(_ctx.$t('rank').toUpperCase()) + "* ", 1),
              _createElementVNode("div", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sort('idInt'))),
                class: "cursor-pointer"
              }, _toDisplayString(_ctx.$t('nft')) + " # ", 1)
            ]),
            _createElementVNode("div", _hoisted_41, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showedMyNfts, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "my-nfts-list-item",
                  onClick: ($event: any) => (_ctx.gotoNftViewer(item))
                }, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("img", {
                      class: "my-nfts-list-item-character-image",
                      src: item.image
                    }, null, 8, _hoisted_44),
                    _createTextVNode(" " + _toDisplayString(item.character?.toUpperCase() || ''), 1)
                  ]),
                  (!_ctx.upToLargeBreakpoint)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(item.myNo), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_46, _toDisplayString(item.price ? item.priceShow : '--'), 1),
                  _createElementVNode("div", _hoisted_47, _toDisplayString(item.stakedShow || '--'), 1),
                  _createElementVNode("div", _hoisted_48, _toDisplayString(item.rank), 1),
                  _createElementVNode("div", _hoisted_49, "№" + _toDisplayString(item.id), 1)
                ], 8, _hoisted_42))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('rank_will_be_confirmed_after_minting_period')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_MintSuccessModal)
  ], 64))
}